import { useMutation } from "react-query";
import { AddAutopay } from "../../../../../actions/Utilities/VendorConfiguration";

const useAddAutopay = () => {
  return useMutation(AddAutopay);
};
export default useAddAutopay;
